/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import {billingSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useGuests} from '../../../../hooks/useGuests'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {BillingModel, MasterBillingDoc} from '../../../../models/billing.model'
import {getListBillingMasterService} from '../../../../services/billing.service'
import {HistoryFilterModel} from '../../../guests/model'
import {paginationGuestsService} from '../../../guests/services'
import {SelectAsync} from '../../../../../../components/UI/SelectV2'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableReportSubFacturation: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, setClearTable} = useKTable()
  const methods = useForm<BillingModel>({
    resolver: yupResolver(billingSchema),
    defaultValues: {
      ClienteId: '',
      CampamentoId: '',
      ModuloId: '',
      HuespedId: '',
      TipoHabitacionId: '',
      FechaPeriodoIni: '',
      FechaPeriodoFin: '',
      HuespedDescripcion: 'TODOS',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [formValue, setFormValue] = useState<any>(null)
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()

  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const [modules, setModules] = useState<SelectOption[]>([])
  const [typeRooms, setTypeRooms] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[] | any>([])
  const [camps, setCamps] = useState<SelectOption[] | any>([])
  const {getClients, getCamps} = useCentralServices()
  const {getModules} = useModules()
  const {getTypeRooms} = useRooms()
  const {getGuests} = useGuests()

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.Id,
      idToDelete: '',
      content: {
        ...currentTabItem.content,
        detailPanel: 'detail-report-sub',
      },
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<MasterBillingDoc>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Inicio' />,
      accessor: 'FechaPeriodoIni',
      Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaPeriodoIni)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Fin' />,
      accessor: 'FechaPeriodoFin',
      Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaPeriodoFin)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
      accessor: 'Cliente_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'Campamento_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Huésped' />,
      accessor: 'Huesped_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Descripción Reporte' />,
      accessor: 'DescripcionReporte',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleViewPanel(props)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  const getModulesFn = async (campId: string) => {
    const data = await getModules({CampamentoId: campId, ClienteId: watch('ClienteId')})
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setModules(allData)
  }

  const getTypeRoomsFn = async () => {
    const data = await getTypeRooms()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setTypeRooms(allData)
  }

  const getCampsFn = async (clientId: string) => {
    const data = await getCamps({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        isCombo: true,
        BuscaTexto: inputValue,
        ...obj,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno} ${guest.NumeroDocumento}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const getBillings = async () => {
    try {
      if (!formValue) return
      const obj = {...formValue}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      setLoading(true)
      const {data: response} = await getListBillingMasterService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTypeRoomsFn()
    getClientsFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      if (pagination.currentPage === 1) {
        getBillings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    reset()
    setFormValue(null)
    setData([])
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setClient([{value: '', label: 'TODOS'}])
    setCamps([{value: '', label: 'TODOS'}])
    setModules([{value: '', label: 'TODOS'}])
    setClearTable(true)
  }

  const onSubmit = (dataForm: HistoryFilterModel) => {
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaPeriodoIni', value)
    setError('FechaPeriodoIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaPeriodoFin', value)
    setError('FechaPeriodoFin', {})
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    getCampsFn(value)
    setModules([{value: '', label: 'TODOS'}])
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setValue('ClienteId', value)
    setError('ClienteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    getModulesFn(value)
    setValue('ModuloId', '')
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', 'TODOS')
    setError('ModuloId', {})
  }

  const handleGuestChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('HuespedId', value)
    setValue('HuespedDescripcion', val.label)
    setError('HuespedId', {})
  }

  const handleRoomTypeChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('TipoHabitacionId', value)
    setError('TipoHabitacionId', {})
  }

  useEffect(() => {
    getBillings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  return (
    <>
      <KTCard shadow className='m-5'>
        <>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Inicio Estadía:</label>
                  <InputDate
                    name='FechaPeriodoIni'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateIni}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Fin de Estadía:</label>
                  <InputDate
                    name='FechaPeriodoFin'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateFin}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleClientChange}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select
                    control={control}
                    name='CampamentoId'
                    data={camps}
                    errors={errors}
                    onChangeValue={handleCampChange}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Módulo:</label>
                  <Select
                    control={control}
                    name='ModuloId'
                    data={modules}
                    errors={errors}
                    onChangeValue={handleModuleChange}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Huésped: (Escriba para buscar un huésped)</label>
                  <SelectAsync
                    loadOptions={loadOptions as any}
                    name='HuespedId'
                    value={{
                      value: watch('HuespedId') || '',
                      label: watch('HuespedDescripcion') || '',
                    }}
                    onChangeValue={handleGuestChange}
                    textPlaceholder='Buscar Huésped...'
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Tipo de Habitación:</label>
                  <Select
                    control={control}
                    name='TipoHabitacionId'
                    data={typeRooms}
                    errors={errors}
                    onChangeValue={handleRoomTypeChange}
                  />
                </div>
              </div>
            </form>
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
              <Button label='Limpiar' onClick={handleClear} />
            </ButtonWrapper>
          </FormProvider>
        </>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={data} columns={columns} />
      </KTCard>
    </>
  )
}

const TableReportFacturationSubWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableReportSubFacturation />
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportFacturationSubWrapper}
